import React from 'react';
import { Box, Alert, AlertTitle } from '@mui/material';

interface ErrorMessageProps {
  message: string;
  details?: string;
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({ message, details }) => (
  <Box sx={{ p: 3 }}>
    <Alert severity="error">
      <AlertTitle>Error</AlertTitle>
      {message}
      {details && <div style={{ marginTop: '8px', fontSize: '0.875rem' }}>{details}</div>}
    </Alert>
  </Box>
);

export default ErrorMessage;
